<style lang="scss">
#select-unit {
  select {
    border-radius: 0 8px 8px 0 !important;
  }
  input {
    border-radius: 8px 0 0 8px !important;
    border-right: none;
  }
  .ex-select {
    background-position-x: 94%;
    border-radius: 0 8px 8px 0 !important;
  }
}
</style>

<template>
  <v-layout id="select-unit" wrap>
    <div class="d-flex" style="width: 100%">
      <v-flex xs8>
        <input-text
          :model.sync="value"
          :error.sync="error.value"
          :regex="regex"
          :maxValue="maxValue"
          :notSmallThan="notSmallThan"
          :isMoney="isMoney"
        />
      </v-flex>
      <v-flex xs4>
        <select-text
          :items="items"
          :id.sync="idBus"
          :label="unitBus"
          :model.sync="unitBus"
          :error.sync="error.unit"
        />
      </v-flex>
    </div>
  </v-layout>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import Select from "@/components/Utils/Select.vue";
export default {
  components: {
    "input-text": Input,
    "select-text": Select
  },
  props: {
    items: Array,
    model: [String, Number],
    id: Number,
    unit: String,
    regex: RegExp,
    error: {
      type: Object,
      default: function() {
        return { value: null, unit: null };
      }
    },
    notSmallThan: Number,
    maxValue: Number,
    isMoney: Boolean
  },
  data() {
    return {
      value: this.model == 0 ? 0 : this.model,
      idBus: this.id,
      unitBus: this.unit
    };
  },
  watch: {
    model(value) {
      this.value = value;
    },
    unit(value) {
      this.unitBus = value;
    },
    value(value) {
      this.$emit("update:model", value);
    },
    unitBus(value) {
      this.$emit("update:unit", value);
    },
    idBus(value) {
      this.$emit("update:id", value);
    },
    error: {
      handler(value) {
        this.$emit("update:error", value);
      },
      deep: true
    }
  }
};
</script>
